
import { apiClient } from "./apiclient";

export const getAllStories = (token) =>
  apiClient.get("/stories", {
    headers: { Authorization: `Bearer ${token}` },
  });

  export const getAllSubTasks = (token) =>
  apiClient.get("/subtasks", {
    headers: { Authorization: `Bearer ${token}` },
  });